import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  imageStyle: {
    padding: 10,
    margin: 8,
    height: 25,
    width: 25,
    resizeMode: 'stretch',
    alignItems: 'center',
  },
});
